/**
 * Holds a list of delayed calls.
 *
 * @var {Object}
 * @private
 */
S._delayedCalls = {};

/**
 * Delays a function call and overrides existing calls in the queue.
 *
 * @param {string} name Queue name to allow multiple calls for different tasks
 * @param {number} delay in milliseconds
 * @param {function} callback Callback function
 *
 * @returns {number} Returns the "setTimeout()" id
 */
S.delayed = function (name, delay, callback)
{
    if (!delay)
    {
        callback.call(this);

        return -1;
    }

    S.clearDelayed(name);

    S._delayedCalls[name] = setTimeout(callback.bind(this), delay);

    return S._delayedCalls[name];
};

/**
 *
 * @param {string} name Queue name to cancel
 * @returns {boolean}
 */
S.clearDelayed = function (name)
{
    if (S._delayedCalls[name])
    {
        clearTimeout(S._delayedCalls[name]);

        S._delayedCalls[name] = 0;

        return true;
    }

    return false;
};
